<template>
    <!--//FIXME: kolor obramowania-->
    <div
        class="px-4 sm:px-6"
        :class="faq.withSections ? 'space-y-10 py-4 sm:py-6' : 'divide-y'"
        :style="{
            'background-color': faq.backColor,
            'border-color': faq.borderColor,
            'border-radius': faq.borderRadius + 'px',
        }"
    >
        <TableSection
            v-for="section in sections"
            :key="section.id"
            :faq="faq"
            :section="section"
            :query="query"
        />
    </div>
</template>

<script>
import TableSection from "./TableSection.vue";

export default {
    name: "TableLayout",
    props: {
        faq: Object,
        sections: Array,
        query: String,
    },
    components: {
        TableSection,
    },
};
</script>
